import axios from 'axios';
import apiConfig from '../api.config';

export default function getGuestlinkSuscriptionStatus({ hotelId }) {
  const {
    host,
    URIs: { guestlinkSuscriptionStatus },
  } = apiConfig;

  const uri = `${host}${guestlinkSuscriptionStatus.replace(':hotelId', hotelId)}`;

  return axios
    .get(uri, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data?.suscription || false;
    }).catch(err => {
      console.error(err);
      return false;
    });
}
